class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

 static renderSectionFromFetch(url, event) {
  fetch(url)
    .then((response) => response.text())
    .then((responseText) => {
      const html = responseText;
      FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
      FacetFiltersForm.renderFilters(html, event);
      FacetFiltersForm.renderProductGridContainer(html);
      FacetFiltersForm.renderProductCount(html);
      if (typeof initializeScrollAnimationTrigger === 'function') 
        initializeScrollAnimationTrigger(responseText);
    });
}



  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
  const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
  const sourceCount = parsedHTML.getElementById('ProductCount');

  const container = document.getElementById('ProductCount');
  const containerDesktop = document.getElementById('ProductCountDesktop');

  if (sourceCount && container) {
    container.innerHTML = sourceCount.innerHTML;
    container.classList.remove('loading');
  }

  if (sourceCount && containerDesktop) {
    containerDesktop.innerHTML = sourceCount.innerHTML;
    containerDesktop.classList.remove('loading');
  }

  document.querySelectorAll(
    '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
  ).forEach((spinner) => spinner.classList.add('hidden'));

  const productGrid = document.getElementById('ProductGridContainer');
  if (productGrid) {
    const collection = productGrid.querySelector('.collection');
    if (collection) collection.classList.remove('loading');
  }
}

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);
    FacetFiltersForm.dedupeMobileAvailabilityToggle();

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static dedupeMobileAvailabilityToggle() {
  const toggles = document.querySelectorAll('#FacetFiltersFormMobile .ds-mobile-stock-toggle');

  toggles.forEach((toggle, index) => {
    if (index > 0) toggle.remove();
  });
}

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    const drawer = document.getElementById('FacetFiltersFormMobile').closest('menu-drawer');

    if (drawer) {
      drawer.bindEvents();
    }
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
  const targetSummaryLabel = target.querySelector('.mobile-facets__summary > div > span:first-child');
  const sourceSummaryLabel = source.querySelector('.mobile-facets__summary > div > span:first-child');

  if (sourceSummaryLabel && targetSummaryLabel) {
    targetSummaryLabel.innerHTML = sourceSummaryLabel.innerHTML;
  }

  const targetFacetsList = target.querySelector('.mobile-facets__list');
  const sourceFacetsList = source.querySelector('.mobile-facets__list');

  if (sourceFacetsList && targetFacetsList) {
    targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
  }
}

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

/* =========================================
   Drip Supply custom Sort By drawer
   Mobile + minimized desktop
   Includes custom draggable scrollbar
   ========================================= */

(() => {
  const clamp = (number, min, max) => {
    return Math.min(Math.max(number, min), max);
  };

  const getScrollbarParts = (drawer) => {
    return {
      panel: drawer?.querySelector('.ds-sort-drawer__panel'),
      scroller: drawer?.querySelector('.ds-sort-drawer__options'),
      track: drawer?.querySelector('.ds-sort-scrollbar'),
      thumb: drawer?.querySelector('.ds-sort-scrollbar__thumb'),
    };
  };

  const updateSortScrollbar = (drawer) => {
    if (!drawer) return;

    const { scroller, track, thumb } = getScrollbarParts(drawer);

    if (!scroller || !track || !thumb) return;

    const scrollableDistance =
      scroller.scrollHeight - scroller.clientHeight;

    if (scrollableDistance <= 1) {
      track.classList.add('is-hidden');
      thumb.style.height = '';
      thumb.style.transform = 'translateY(0)';
      thumb.dataset.top = '0';
      thumb.dataset.maxTop = '0';
      return;
    }

    track.classList.remove('is-hidden');

    const trackHeight = track.clientHeight;

    if (trackHeight <= 0) return;

    const visibleRatio =
      scroller.clientHeight / scroller.scrollHeight;

    const thumbHeight = Math.max(
      trackHeight * visibleRatio,
      24
    );

    const maximumThumbTop = Math.max(
      trackHeight - thumbHeight,
      0
    );

    const scrollRatio =
      scrollableDistance > 0
        ? scroller.scrollTop / scrollableDistance
        : 0;

    const thumbTop = maximumThumbTop * scrollRatio;

    thumb.style.height = `${thumbHeight}px`;
    thumb.style.transform = `translateY(${thumbTop}px)`;

    thumb.dataset.top = String(thumbTop);
    thumb.dataset.maxTop = String(maximumThumbTop);
  };

  const initializeSortScrollbar = (drawer) => {
    if (
      !drawer ||
      drawer.dataset.scrollbarInitialized === 'true'
    ) {
      return;
    }

    const { scroller, track, thumb } =
      getScrollbarParts(drawer);

    if (!scroller || !track || !thumb) return;

    drawer.dataset.scrollbarInitialized = 'true';

    scroller.addEventListener(
      'scroll',
      () => {
        updateSortScrollbar(drawer);
      },
      { passive: true }
    );

    thumb.addEventListener('pointerdown', (event) => {
      event.preventDefault();
      event.stopPropagation();

      const trackHeight = track.clientHeight;
      const thumbHeight = thumb.offsetHeight;

      const maximumThumbTop = Math.max(
        trackHeight - thumbHeight,
        0
      );

      if (maximumThumbTop <= 0) return;

      const startingPointerY = event.clientY;

      const startingThumbTop =
        Number.parseFloat(thumb.dataset.top || '0') || 0;

      track.classList.add('is-dragging');

      if (thumb.setPointerCapture) {
        thumb.setPointerCapture(event.pointerId);
      }

      const onPointerMove = (moveEvent) => {
        const movement =
          moveEvent.clientY - startingPointerY;

        const newThumbTop = clamp(
          startingThumbTop + movement,
          0,
          maximumThumbTop
        );

        const scrollableDistance =
          scroller.scrollHeight - scroller.clientHeight;

        scroller.scrollTop =
          maximumThumbTop > 0
            ? (
                newThumbTop /
                maximumThumbTop
              ) * scrollableDistance
            : 0;

        thumb.dataset.top = String(newThumbTop);
        thumb.style.transform =
          `translateY(${newThumbTop}px)`;
      };

      const stopDragging = () => {
        track.classList.remove('is-dragging');

        document.removeEventListener(
          'pointermove',
          onPointerMove
        );

        document.removeEventListener(
          'pointerup',
          stopDragging
        );

        document.removeEventListener(
          'pointercancel',
          stopDragging
        );

        updateSortScrollbar(drawer);
      };

      document.addEventListener(
        'pointermove',
        onPointerMove
      );

      document.addEventListener(
        'pointerup',
        stopDragging
      );

      document.addEventListener(
        'pointercancel',
        stopDragging
      );
    });

    track.addEventListener('pointerdown', (event) => {
      if (event.target === thumb) return;

      const trackRect = track.getBoundingClientRect();
      const thumbHeight = thumb.offsetHeight;

      const maximumThumbTop = Math.max(
        track.clientHeight - thumbHeight,
        0
      );

      const clickedThumbTop = clamp(
        event.clientY -
          trackRect.top -
          thumbHeight / 2,
        0,
        maximumThumbTop
      );

      const scrollableDistance =
        scroller.scrollHeight - scroller.clientHeight;

      scroller.scrollTop =
        maximumThumbTop > 0
          ? (
              clickedThumbTop /
              maximumThumbTop
            ) * scrollableDistance
          : 0;
    });

    updateSortScrollbar(drawer);
  };

  const openDrawer = (trigger) => {
    const drawerId =
      trigger.getAttribute('aria-controls');

    const drawer = document.getElementById(drawerId);

    if (!drawer) return;

    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    trigger.setAttribute('aria-expanded', 'true');

    document.body.classList.add(
      'ds-sort-drawer-open'
    );

    initializeSortScrollbar(drawer);

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        updateSortScrollbar(drawer);
      });
    });

    const closeButton = drawer.querySelector(
      '.ds-sort-drawer__close'
    );

    if (closeButton) closeButton.focus();
  };

  const closeDrawer = (drawer) => {
    if (!drawer) return;

    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');

    document.body.classList.remove(
      'ds-sort-drawer-open'
    );

    const trigger = document.querySelector(
      `.ds-sort-trigger[aria-controls="${drawer.id}"]`
    );

    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
      trigger.focus();
    }
  };

  const applySort = (option, drawer) => {
    const sortValue = option.dataset.sortValue;

    if (!sortValue) return;

    drawer
      .querySelectorAll('.ds-sort-option')
      .forEach((button) => {
        button.classList.toggle(
          'is-active',
          button === option
        );
      });

    closeDrawer(drawer);

    const searchParams = new URLSearchParams(
      window.location.search
    );

    searchParams.set('sort_by', sortValue);

    FacetFiltersForm.renderPage(
      searchParams.toString(),
      null,
      true
    );
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest(
      '.ds-sort-trigger'
    );

    if (trigger) {
      event.preventDefault();
      openDrawer(trigger);
      return;
    }

    const closeButton = event.target.closest(
      '.ds-sort-drawer__close'
    );

    const overlay = event.target.closest(
      '.ds-sort-drawer__overlay'
    );

    if (closeButton || overlay) {
      event.preventDefault();

      const drawer = event.target.closest(
        '.ds-sort-drawer'
      );

      closeDrawer(drawer);
      return;
    }

    const sortOption = event.target.closest(
      '.ds-sort-option'
    );

    if (sortOption) {
      event.preventDefault();

      const drawer = sortOption.closest(
        '.ds-sort-drawer'
      );

      applySort(sortOption, drawer);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    const openSortDrawer = document.querySelector(
      '.ds-sort-drawer.is-open'
    );

    if (openSortDrawer) {
      closeDrawer(openSortDrawer);
    }
  });

  window.addEventListener(
    'resize',
    () => {
      document
        .querySelectorAll('.ds-sort-drawer')
        .forEach((drawer) => {
          updateSortScrollbar(drawer);
        });
    },
    { passive: true }
  );
})();
